import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';

@Component
/**
 * ProductsRate Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Count of rate
     */
    @Prop({ type: [String, Number], default: 0 }) rateCount!: number | string;

    /**
     * Average of rate
     */
    @Prop({ type: [String, Number], default: 0 }) rateAverage!: number | string;

    /**
     * Base gutter for rate
     */
    @Prop({ default: 5 }) rateGutter!: number | string;

    /**
     * post hashid
     */
    @Prop({ type: String }) postId!: string;

    /**
     * Config for rating
     */
    @Prop({ type: Object }) rateConfig!: {[k: string]: number | string | boolean};

    /**
     * Rate Items split
     */
    @Prop({ type: Array }) rateItems!: Array<any>;

    /**
     * User rate
     */
    @Prop({ type: [String, Number], default: 0 }) userRate!: number | string;
}
